export default routesLayout;

/** @ngInject */
function routesLayout($stateProvider) {
  $stateProvider
    .state('layout', {
      abstract: true,
      parent: 'app',
      views: {
        'header@': {
          component: 'headerComponent'
        },
        'footer@': {
          component: 'footerComponent'
        }
      },
      resolve: {
        currentClassRoom: ClassRoomService => ClassRoomService.getCurrentClassRoom(),
        classRooms: ClassRoomService => ClassRoomService.getClassRooms(),
        schoolCommonRooms: SchoolCommonRoomService => SchoolCommonRoomService.getSchoolCommonRooms()
        // Me: SchoolCommonRoomService => SchoolCommonRoomService.getMe()
      }
    });
}
